import { Image } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const UploadLogoModal = styled.div`
  width: 100%;

  .branding-button {
    align-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    font-size: 18px;
    text-decoration: underline;
    transition: 0.25s;

    &:hover {
      color: var(--color-accent-secondary-default);
    }

    svg {
      margin-left: 16px;
    }
  }
`;

const CropImageArea = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
`;

const PreviewCard = styled.div`
  background: var(--color-bg-default);
  border-radius: var(--size-border-radius-lg);
  display: flex;
  justify-content: center;
  padding: var(--size-padding-80) var(--size-padding-0) var(--size-padding-56) var(--size-padding-0);
  position: relative;
  width: 632px;

  ${Image.S.Image} {
    max-height: 200px;
    max-width: 200px;
    object-fit: contain;
  }
`;

const PreviewCardInner = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-32);
  width: 336px;
`;

const ButtonGroup = styled.div`
  width: 100%;
`;

const PreviewWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const GiftMessageWrapper = styled.div`
  background: var(--color-bg-weaker2);
  border-radius: var(--size-border-radius-md);
  padding: var(--size-padding-56) var(--size-padding-16);
  width: 100%;
`;

const GiftMessage = styled.div`
  font-size: 18px;
  font-style: italic;
  font-weight: 400;
  text-align: center;
`;

const SkipUnWrapWrapper = styled.div`
  margin-top: 12px;

  button {
    color: var(--color-fg-weaker);
  }
`;

export {
  ButtonGroup,
  CropImageArea,
  GiftMessage,
  GiftMessageWrapper,
  PreviewCard,
  PreviewCardInner,
  PreviewWrapper,
  SkipUnWrapWrapper,
  UploadLogoModal
};
